import { rem } from 'polished'

import { css, styled } from '../theme'
import { colors } from '../theme/colors'
import { Size, SizeName } from '../theme/size'

export interface Props {
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  grey?: boolean
  size?: SizeName
}

export const Box = styled.div.attrs(p => ({}))<Props>`
  
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-shrink:0;
  justify-content:center;
  justify-items: flex-start;
  padding: ${p => p.size && rem(Size[p.size])}; 
  
  ${p =>
    ((!p.primary && !p.secondary && !p.tertiary && !p.grey) || p.primary) &&
    css`
      background-color: ${colors.primaryLight};
      color: ${colors.primary};
    `}

  ${p =>
    p.secondary &&
    css`
      background-color: ${colors.secondaryLight};
      color: ${colors.secondary};
    `}

  ${p =>
    p.tertiary &&
    css`
      background-color: ${colors.ternaryLight};
      color: ${colors.ternary};
    `}

  ${p =>
    p.grey &&
    css`
      background-color: ${colors.greyLight};
    `}
`
